import { Link, Outlet } from "react-router-dom";
import "./dashboard.css";

function Dashboard() {
  return (
    <div>
      <div className="sidebar">
        <Link to="ManageBookings">Bookings</Link>
        <Link to="ManageCars">Cars</Link>
      </div>

      <div className="content">
        <Outlet />
      </div>
    </div>
  );
}

export default Dashboard;
